export default __webpack_public_path__ + "static/media/avatar2.48b7d639.svg";